import type _Vue from 'vue'
import CloudflareTurnstileModal from '@/components/login/CloudflareTurnstileModal.vue'

export interface ICloudflareTurnstile {
  showChallenge: (parent: Vue) => Promise<{ cancelled: true } | { cancelled: false, token?: string }>
}

class CloudflareTurnstile implements ICloudflareTurnstile {
  private vue: typeof _Vue

  constructor(Vue: typeof _Vue) {
    this.vue = Vue
  }

  showChallenge(parent: Vue): Promise<{ cancelled: true } | { cancelled: false, token?: string }> {
    if (window.injectedEnv.FRONTEND_CLOUDFLARE_TURNSTILE_ENABLED !== 'true')
      return Promise.resolve({ cancelled: false, token: undefined })
    const CloudflareTurnstileModalComponent = this.vue.extend(CloudflareTurnstileModal)
    const component = new CloudflareTurnstileModalComponent({
      el: document.createElement('div'),
    })

    parent.$el.appendChild(component.$el)

    return new Promise<{ cancelled: true } | { cancelled: false, token: string }>((resolve) => {
      component.$off('complete')
      component.$off('cancel')

      component.$on('complete', (token: string) => {
        resolve({ cancelled: false, token })
        parent.$el.removeChild(component.$el)
        component.$destroy()
      })
      component.$on('cancel', () => {
        resolve({ cancelled: true })
        parent.$el.removeChild(component.$el)
        component.$destroy()
      })
    })
  }
}

export default function CloudflareTurnstilePlugin(Vue: typeof _Vue): void {
  Vue.prototype.$turnstile = new CloudflareTurnstile(Vue)
}
